{
  "version": 1,
  "asset_id": "63a6c2c5-b7ac-41b1-bce4-d999438699c6",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/63a6c2c5-b7ac-41b1-bce4-d999438699c6/svc-aeo-geo-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/63a6c2c5-b7ac-41b1-bce4-d999438699c6/svc-aeo-geo-1200.webp",
  "original_filename": "svc-aeo-geo-1200.webp",
  "size": 7516,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:38Z"
}
